import React, { useEffect, useState } from 'react';
import testimonial1 from '../Assest/Images1.webp'; 
import testimonial2 from '../Assest/Images2.webp'; 
import testimonial3 from '../Assest/Images3.webp'; 
import testimonial4 from '../Assest/Images4.webp'; 
import testimonial5 from '../Assest/Images5.webp'; 
import testimonial6 from '../Assest/Images6.webp'; 

const testimonialImages = [
  { src: testimonial1, alt: 'WhatsApp Testimonial 1' },
  { src: testimonial2, alt: 'WhatsApp Testimonial 2' },
  { src: testimonial3, alt: 'WhatsApp Testimonial 3' },
  { src: testimonial4, alt: 'WhatsApp Testimonial 4' },
  { src: testimonial5, alt: 'WhatsApp Testimonial 5' },
  { src: testimonial6, alt: 'WhatsApp Testimonial 6' },
];

const WhatsAppTestimonials = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getColumns = () => {
    if (windowWidth <= 600) return 1;
    if (windowWidth <= 900) return 2;
    if (windowWidth <= 1400) return 3;
    return 3;
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Real Results, Real Stories</h2>
      <p style={{ textAlign: 'center', color: '#fff', marginBottom: '40px' }}>
        Trained over 20,000 people
      </p>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${getColumns()}, 1fr)`,
          gap: '20px',
          justifyItems: 'center',
          alignItems: 'stretch',
          maxWidth: '1000px',
          margin: '0 auto',
        }}
      >
        {testimonialImages.map((item, index) => (
          <div key={index} style={styles.card}>
            <img src={item.src} alt={item.alt} style={styles.image} />
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <button
          style={{
            background: 'linear-gradient(49.12deg, #ffc74b 0, #e39600 22%)',
            color: 'white',
            fontSize: windowWidth <= 768 ? '18px' : '20px',
            padding: windowWidth <= 768 ? '10px 40px' : '25px 80px',
            border: 'none',
            borderRadius: '20px',
            fontWeight: 'bold',
            cursor: 'pointer',
            width: windowWidth <= 768 ? '100%' : 'auto',
            fontFamily: 'outfit,sans-serif',
          }}
        >
          See More Inside The 2 Day Workshop
        </button>
        <p
          style={{
            marginTop: '10px',
            color: 'white',
            fontSize: '16px',
            fontFamily: 'outfit,sans-serif',
            fontStyle: 'italic',
          }}
        >
          Registrations End on{' '}
          <span style={{ fontWeight: 'bold', color: 'red' }}>11 JUL</span> <br />
          100% मनी बॅक गॅरंटी | समाधानी नसल्यास
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    background: 'linear-gradient(180deg, #000b3e 0, #020202 59%)',
    padding: '40px 20px',
    textAlign: 'center',
    fontFamily: 'outfit, sans-serif',
  },
  heading: {
    color: '#fff',
    fontSize: '32px',
    fontWeight: '600',
    marginBottom: '10px',
  },
  card: {
    backgroundColor: '#fff',
    border: '1px solid #fff',
    overflow: 'hidden',
    width: '100%',
    maxWidth: '320px',
    boxShadow: '0 6px 12px rgba(0,0,0,0.2)',
  },
  image: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
};

export default WhatsAppTestimonials;
